import { useEffect, useRef } from 'react';
import { company, emailHref, phoneHref } from '../data/company';
import { informationTitles as titles } from '../data/informationPages';
import './InformationPage.css';

function ContactLinks() {
  return <><a href={emailHref}>{company.contacts.email}</a> или <a href={phoneHref}>{company.contacts.phone_display}</a></>;
}

function Contacts() {
  const { organization: org, bank_account: bank } = company;
  return <>
    <section aria-labelledby="contact-heading">
      <h2 id="contact-heading">Связаться с оператором платформы</h2>
      <address><ContactLinks /></address>
      <p>Обращайтесь по вопросам сервиса, заказов, отмены и возврата. Для обращения не требуется входить в аккаунт.</p>
    </section>
    <section aria-labelledby="company-heading">
      <h2 id="company-heading">Организация</h2>
      <dl className="information-details">
        <div><dt>Полное наименование</dt><dd>{org.full_name}</dd></div>
        <div><dt>Сокращённое наименование</dt><dd>{org.short_name}</dd></div>
        <div><dt>ИНН</dt><dd>{org.inn}</dd></div>
        <div><dt>КПП</dt><dd>{org.kpp}</dd></div>
        <div><dt>ОГРН</dt><dd>{org.ogrn}</dd></div>
        <div><dt>Юридический адрес</dt><dd>{org.legal_address}</dd></div>
      </dl>
      <p>Эти реквизиты относятся к оператору платформы. Продавец конкретного товара указывается отдельно. Юридический адрес не является адресом склада, самовывоза или приёма возвратов.</p>
    </section>
    <section aria-labelledby="bank-heading">
      <h2 id="bank-heading">Банковские реквизиты организации</h2>
      <dl className="information-details">
        <div><dt>Расчётный счёт</dt><dd>{bank.settlement_account}</dd></div>
        <div><dt>Банк</dt><dd>{bank.bank_name}</dd></div>
        <div><dt>ИНН банка</dt><dd>{bank.bank_inn}</dd></div>
        <div><dt>БИК банка</dt><dd>{bank.bank_bik}</dd></div>
        <div><dt>Корреспондентский счёт</dt><dd>{bank.correspondent_account}</dd></div>
        <div><dt>Юридический адрес банка</dt><dd>{bank.bank_legal_address}</dd></div>
      </dl>
      <p>Реквизиты приведены для ознакомления с организацией. Покупки и приём оплаты на сайте пока недоступны.</p>
    </section>
  </>;
}

function Payment() {
  return <>
    <p className="information-notice">Оформление покупок и приём оплаты на сайте пока недоступны.</p>
    <h2>Цены и сумма покупки</h2>
    <p>Цены товаров в каталоге и корзине указываются в российских рублях (₽). Сумма выбранных товаров в корзине не подтверждает оформление или оплату заказа. Расчёт доставки и окончательной суммы к оплате пока недоступен.</p>
    <h2>Способы оплаты и чек</h2>
    <p>Оплата банковской картой, через СБП и Robokassa на сайте не подключена. Сайт пока не принимает платежи и не формирует кассовые чеки. Доступные способы расчётов и порядок получения чека будут опубликованы до запуска покупок.</p>
    <h2>Вопросы о расчётах</h2>
    <p>Если вопрос связан с ранее оформленным заказом или платежом, сообщите номер заказа, дату и сумму: <ContactLinks />. Не передавайте коды из SMS, пароли и полные данные банковской карты.</p>
    <p>Смотрите также <a href="/returns">порядок обращения по возврату</a>.</p>
  </>;
}

function Delivery() {
  return <>
    <p className="information-notice">Оформление доставки на сайте пока недоступно.</p>
    <h2>Способы получения и территория</h2>
    <p>Подтверждённые способы получения, территория обслуживания и пункты выдачи для покупок на сайте пока не опубликованы. Выбор Яндекс ПВЗ и заказ Яндекс Доставки на сайте недоступны.</p>
    <h2>Сроки, стоимость и получение</h2>
    <p>Сроки и стоимость доставки, способ их расчёта и порядок получения будут опубликованы до запуска покупок. Сейчас сайт не рассчитывает доставку и окончательную сумму заказа; сумма в корзине отражает выбранные товары.</p>
    <h2>Вопросы о заказе</h2>
    <p>По вопросам ранее оформленного заказа свяжитесь с оператором: <ContactLinks />. Укажите номер заказа и продавца, если они известны. Условия получения необходимо уточнить по конкретному заказу.</p>
    <p>Юридический адрес оператора не является адресом самовывоза. См. <a href="/contacts">контакты и реквизиты</a>.</p>
  </>;
}

function Returns() {
  return <>
    <p className="information-notice">Покупки и оплата на сайте пока недоступны. По вопросам ранее оформленных заказов можно обратиться без входа в аккаунт.</p>
    <section>
      <h2>Как обратиться</h2>
      <p>Напишите на <a href={emailHref}>{company.contacts.email}</a> или позвоните по номеру <a href={phoneHref}>{company.contacts.phone_display}</a>. Сообщите номер и дату заказа, товар, продавца (если известен), причину обращения и способ связи. При недостатках приложите описание и, при наличии, фотографии. Отсутствие бумажного чека само по себе не лишает потребителя права обратиться.</p>
      <p>По обращению требуется установить заказ и продавца, определить применимое требование и согласовать способ передачи товара, если она необходима. Конкретный адрес и способ передачи уточняются по заказу; не отправляйте товар на юридический адрес оператора без согласования.</p>
    </section>
    <section>
      <h2>Отмена до получения</h2>
      <p>При дистанционной продаже потребитель вправе отказаться от товара в любое время до его передачи (статья 26.1 Закона РФ «О защите прав потребителей»). Для обращения об отмене воспользуйтесь указанными контактами. Статус отмены заказа сам по себе не подтверждает возврат денег.</p>
    </section>
    <section>
      <h2>Возврат товара надлежащего качества</h2>
      <p>При дистанционной покупке отказаться от товара можно в течение семи дней после передачи. Если информация о порядке и сроках возврата не была предоставлена в письменной форме при доставке, срок составляет три месяца с момента передачи. Необходимо сохранить товарный вид и потребительские свойства; покупку можно подтвердить и иными доказательствами, помимо чека.</p>
      <p>Право отказа от качественного товара с индивидуально определёнными свойствами ограничено законом, если товар может использоваться исключительно приобретающим его потребителем. Применимость этого правила определяется по конкретному товару, а не по общему списку на сайте.</p>
    </section>
    <section>
      <h2>Если обнаружен недостаток</h2>
      <p>Требования к продавцу, порядок проверки качества и сроки определяются статьями 18–24 Закона РФ «О защите прав потребителей» с учётом товара, гарантии и характера недостатка. Можно заявить предусмотренное законом требование, в том числе о замене, устранении недостатков, снижении цены или возврате денег. Для технически сложных товаров действуют специальные правила статьи 18.</p>
      <p>При возврате товара с недостатками продавец принимает товар и при необходимости проводит проверку качества. Доставка крупногабаритного товара и товара весом более пяти килограммов для возврата осуществляется силами и за счёт продавца; при неисполнении этой обязанности покупатель вправе потребовать возмещения расходов в установленном законом порядке.</p>
    </section>
    <section>
      <h2>Возврат денег и расходы</h2>
      <p>При правомерном отказе от качественного товара по статье 26.1 продавец возвращает уплаченную сумму не позднее десяти дней со дня предъявления требования, за исключением расходов продавца на доставку возвращённого товара от покупателя. Требование о возврате денег за товар с недостатком по статье 22 также подлежит удовлетворению в течение десяти дней со дня предъявления требования.</p>
      <p>Способ возврата денег и передачи товара требуется согласовать по конкретному заказу и фактическому платежу. Автоматический банковский возврат на сайте не подключён. Обращение к оператору не ограничивает право предъявить требование непосредственно продавцу и не заменяет обязанностей продавца или оператора, установленных законом.</p>
    </section>
  </>;
}

function Offer() {
  return <>
    <p className="information-notice">Покупательская публичная оферта пока не опубликована. Оформление покупок и приём оплаты на сайте недоступны.</p>
    <p>После утверждения условий покупки здесь будет размещён полный текст оферты для покупателей с датой вступления в силу. Оферта для продавцов и договор платёжного оператора являются отдельными документами.</p>
    <h2>Доступная информация</h2>
    <p>Сейчас можно ознакомиться с <a href="/terms/">действующими условиями использования сервиса</a>, <a href="/privacy/">опубликованной политикой конфиденциальности</a>, <a href="/contacts">контактами и реквизитами оператора</a>, информацией об <a href="/payment">оплате</a>, <a href="/delivery">доставке</a> и <a href="/returns">возврате и отмене</a>.</p>
    <p>По вопросам документов обращайтесь: <ContactLinks />.</p>
  </>;
}

const content = { '/contacts': Contacts, '/payment': Payment, '/delivery': Delivery, '/returns': Returns, '/offer': Offer };

export default function InformationPage({ path }: { path: keyof typeof titles }) {
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${titles[path]} — ${company.organization.short_name}`;
    window.scrollTo({ top: 0, behavior: 'instant' });
    heading.current?.focus({ preventScroll: true });
    return () => { document.title = previousTitle; };
  }, [path]);
  const Content = content[path];
  return <main className="information-page">
    <nav aria-label="Хлебные крошки"><a href="/">Главная</a><span aria-hidden="true"> / </span><span>{titles[path]}</span></nav>
    <article className="information-card">
      <h1 ref={heading} tabIndex={-1}>{titles[path]}</h1>
      <Content />
    </article>
  </main>;
}
